const routes = {
    '/': "Echo Scribe",
    '/mentor': "Mentor Notes",
    '/now': "DELAY NO MORE",
    '/talkgpt': "Talk to AI",
    '/workgpt': "AI Assistant",
    '/about': "About"
}

export default routes;